<section class="pageTitle vh-70 d-flex align-items-center justify-content-center flex-column pt-5">
    <h1 class="mb-5" data-aos="fade-up" data-aos-duration="1000"> @if (isArabic) { برامجنا الإذاعية } @else { Our Programs } </h1> 
    <div>
        <span> <a routerLink="/home"> @if (isArabic) { الرئيسية } @else { Home } </a> </span>
        <b class="mx-2"> - </b> 
        <span> <a routerLink="/programs"> @if (isArabic) { برامجنا الإذاعية } @else { Our Programs } </a> </span>
     </div> 
</section>

<section class="programs-section py-5">
  
    <div class="container">
      <div class="row g-4">
  
        <!-- Card 1 -->
        <div class="col-md-4">
          <div class="program-card">
            <img src="assets/images/programs/p1.jpg" class="program-img" alt="شتاء بدون شتاء" />
            <div class="program-info">
              <h4 class="program-title">شتاء بدون شتاء</h4> 
              <p class="program-time">كل يوم إثنين الساعة 6 مساءً</p>
              <p class="program-host">مع ميرنا الحسيني</p>
            </div>
          </div>
        </div>
  
        <!-- Card 2 -->
        <div class="col-md-4">
          <div class="program-card">
            <img src="assets/images/programs/p1.jpg" class="program-img" alt="يوم جديد" />
            <div class="program-info">
              <h4 class="program-title">يوم جديد</h4>
              <p class="program-time">الأربعاء والسبت الساعة 10 مساءً</p>
              <p class="program-host">مع مروان سعد</p>
            </div>
          </div>
        </div>
  
        <!-- Card 3 -->
        <div class="col-md-4">
          <div class="program-card">
            <img src="assets/images/programs/p1.jpg" class="program-img" alt="ضيف مؤثر" />
            <div class="program-info">
              <h4 class="program-title">ضيف مؤثر</h4>
              <p class="program-time">كل يوم إثنين الساعة 8 مساءً</p>
              <p class="program-host">مع وليد العطار</p>
            </div>
          </div>
        </div>
  
      </div>

      <div class="join-program text-center pt-5">
        <h2> @if (isArabic) { انضم الان لفريق مذيعين راديو الغردقة } @else { Join the Hurghada Radio broadcasting team now } </h2>
        <button class="btn btn-outline-info  rounded-5" routerLink="/contact"> @if (isArabic) { انضم الان } @else { Join Now } </button>
      </div>

    </div>

  </section>
  